import { render, staticRenderFns } from "./BillRetrospect.vue?vue&type=template&id=700ec950"
import script from "./BillRetrospect.vue?vue&type=script&lang=js"
export * from "./BillRetrospect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports